// Shared content used across the new homepage sections.

export const sectors = [
  "Oil & Gas",
  "Financial Services",
  "Manufacturing",
  "Technology",
  "Healthcare",
  "Real Estate",
  "Telecommunications",
  "Public Sector",
];

export const process = [
  {
    num: "01",
    title: "Discover & Diagnose",
    body: "We invest time upfront to understand your business, industry, and risk profile, grounded in real research.",
  },
  {
    num: "02",
    title: "Strategise & Design",
    body: "We craft tailored, practical strategies and frameworks built around your specific goals and challenges.",
  },
  {
    num: "03",
    title: "Implement & Optimise",
    body: "We work alongside your team to deliver, refining as we go to ensure measurable, lasting results.",
  },
  {
    num: "04",
    title: "Sustain & Partner",
    body: "We stay engaged as long-term partners, supporting sustainable growth and operational resilience.",
  },
];

// Animated stat band targets. Update these figures when final numbers are confirmed.
export const statCards = [
  { target: 24, suffix: "+", label: "Years of Experience" },
  { target: 100, suffix: "+", label: "Clients Served" },
  { target: 8, suffix: "", label: "Service Pillars" },
  { target: 45, suffix: "+", label: "Yrs Combined Leadership" },
];
